<template>
  <div class="container bg-light position-fixed top-50 start-50 translate-middle w-50 border border-danger p-3"
    style="border-radius: 10px">
    <div class="p-1">
      <button class="btn-close float-end mt-1" @click.prevent="close">
      </button>
      <h3 class="mt-3"> <strong> Editar precio</strong></h3>
      <p for="editPriceValue">Nuevo valor para el precio <strong> {{ priceInfo.name }} </strong></p>
      <input type="number" class="form-control mb-3 w-75 mx-auto" min="0" step="100" v-model="editPriceValue"
        id="editPriceValue">
      <button class="btn btn-danger my-2" @click.prevent="saveChanges()">Actualizar precio</button>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  props: {
    getPriceIdToEdit: Number,
  },
  data() {
    return {
      editPriceValue: 0,
      priceInfo: [],
    }
  },
  watch: {
    getPriceIdToEdit(newVal) {
      if (newVal !== null) {
        this.getPriceInfo();
      }
    },
  },
  methods: {
    close() {
      this.priceInfo = [];
      this.$emit("hideEditPrice", false);
    },
    getPriceInfo() {
      try {
        axios.get(RUTA_SERVIDOR + "api/price/get", {
          params: {
            price_id: this.getPriceIdToEdit,
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
          //.then((res)=> console.log(res.data[0]))
          .then((res) => (this.priceInfo = res.data[0]))
          .catch((err) => console.log(`There has been an error ${err}`));
      } catch (err) {
        console.log(`An error has occurred: ${err}`);
      }
    },
    async saveChanges() {
      if (this.priceInfo.id === 0 || this.priceInfo.id == null) {
        alert("Id del precio no válido.")
      } else {
        let formData = new FormData();
        formData.append("price_id", this.priceInfo.id);
        //formData.append("name", this.editPriceName);
        formData.append("value", this.editPriceValue);
        try {
          let res = await axios.post(
            RUTA_SERVIDOR + "api/price/update",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          );
          //console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            alert("Precio: " + this.priceInfo.name + ", actualizado con exito!");
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
        this.$emit("hideEditPrice", false);
        this.priceInfo = [];
        location.reload();
      }
    },
  }
}
</script>
<style scoped></style>